export const PRIORITIES_LABELS = {
    LOW: "Faible",
    MEDIUM: "Moyenne",
    HIGH: "Importante",
};

export const PRIORITIES_CLASSES = {
    LOW: "primary",
    MEDIUM: "warning",
    HIGH: "danger",
};

export const STATUS_OPTIONS = {
    PENDING: "En attente",
    IN_PROGRESS: "En cours",
    SCHEDULED: "Programmé",
    NOT_REQUIRED: "Non nécessaire",
    RESOLVED: "Résolu",
};

export const STATUS_CLASSES = {
    PENDING: "secondary",
    IN_PROGRESS: "primary",
    SCHEDULED: "info",
    NOT_REQUIRED: "dark",
    RESOLVED: "success",
};

export const PRIORITIES = Object.entries(PRIORITIES_LABELS).map(([value, label]) => ({ value, label }));

export const ROLE_LABELS = {
    ROLE_ADMIN: "Administrateur",
    ROLE_MANAGER: "Manager",
    ROLE_FLEET_MANAGER: "Gestionnaire de flotte",
    ROLE_EMPLOYEE: "Employé"
};

export const ROLE_CLASSES = {
    ROLE_ADMIN: "primary",
    ROLE_MANAGER: "success",
    ROLE_FLEET_MANAGER: "info",
    ROLE_EMPLOYEE: "secondary"
};
